import React from 'react'
import { Carousel } from 'react-carousel-minimal';

//imagenes
import SHOT1 from '../../../images/carrusel/SHOT1.png';
import SHOT2 from '../../../images/carrusel/SHOT2.png';
import SHOT3 from '../../../images/carrusel/SHOT3.png';
import SHOT4 from '../../../images/carrusel/SHOT4.png';


export default function Carrusel() {

    const soht1Text = `<div class='carrusel--container-text'>
        <h1>Proyectos llave en mano</h1>
        <p > Tu Proyecto de calderas de principio a fin.</p>
        <a href='/servicios/proyectomano' class="btn-custom_carrusel">ver más</a>
        </div>`;

    const soht2 = `<div class='carrusel--container-text'>
        <h1>Venta de calderas y refacciones.</h1> 
        <p>Los Mejores equipos, ajustados a tus requerimientos.</p>
        <a href='/servicios/serviciosadicionales' class="btn-custom_carrusel">ver más</a>
        </div>`;



    const soht3 = `<div class='carrusel--container-text'>
        <h1>Ahorro de energía y renta de calderas.</h1>
        <a href='/servicios/serviciosadicionales' class="btn-custom_carrusel">ver más</a>
        </div>`;


    const soht4 = `<div class='carrusel--container-text'>
            <h1>Cursos de capacitacion.</h1>
            <p>Diseñados para generar las mejores prácticas de <br/>
                operación y optimización en el uso de los recursos.</p>
            <a href='/servicios/capacitacion' class="btn-custom_carrusel">ver más</a>
        </div>`;


    const data = [
        {
            image: SHOT1,
            caption: soht1Text
        },
        {
            image: SHOT2,
            caption: soht2
        },
        {
            image: SHOT3,
            caption: soht3
        },
        {
            image: SHOT4,
            caption: soht4
        }
    ];

    return (

        < >

            <Carousel
                captionPosition="top"
                slideBackgroundColor="darkgrey"
                slideImageFit="cover"
                data={data}
                automatic={true}
                time={10000}
                width="100%"
                dots={true}
                height="50em"
            />
        </>

    )
}
